export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
export const PHONE_REGEX =
  /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const ZIP_REGEX = /^\d{5}$/;
export const MONEY_REGEX = /^\d+$/;

export const REQUIRED_FIELD_MESSAGE = 'This is a required field';
export const INCORRECT_FORMAT_MESSAGE = (fieldName: string) =>
  `Please enter a valid ${fieldName}`;
export const OWNS_HOME_ERROR_MESSAGE =
  "We're sorry, but you'll only be able to purchase solar if you own your home.";
